export default __webpack_public_path__ + "static/media/SLoader.69448193.svg";